











































































































import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ImageUploadBlock from '@/componentsV2/molecules/Inputs/ImageUploadBlock.vue';
import ColorPicker from '@/componentsV2/molecules/ColorPicker/ColorPicker.vue';
import CoinAnatomy from '@/components/icons/CoinAnatomy.vue';
import CoinAnatomySafari from '@/components/icons/CoinAnatomySafari.vue';
import { BusinessOnboardingYourDigitalCoinsForm } from '@/models/business-onboarding';
import YourDigitalCoinBase from '@/views/BusinessOnboarding/online/Steps/YourDigitalCoinBase.vue';
import InviteMerchantSignupModalsModel from '@/views/Models/InviteMerchantSignupModalsModel.vue';
import { colorDefaultData } from '@/componentsV2/molecules/ColorPicker/colorsDictionary';

import eventBus from '@/utils/eventBus';
import { isSafari } from '@/utils/is-safari';
import { isExternalOauthSessionOnline } from '@/router/router-utils';
import { ReserveCoinInformations } from '@/models/coin-setup';
import recaptchaRoutesKeys from '@/constants/recaptchaRoutesKeys';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    Typography,
    CloseModalIcon,
    FilledButton,
    ValidationObserver,
    ValidationProvider,
    ImageUploadBlock,
    ColorPicker,
    CoinAnatomy,
    CoinAnatomySafari
  }
})
export default class EditBusinessLogo extends Mixins(
  Vue,
  InviteMerchantSignupModalsModel,
  YourDigitalCoinBase
) {
  @Prop() readonly code!: string;
  @Prop() readonly businessId!: string;
  @Prop() readonly coinData!: BusinessOnboardingYourDigitalCoinsForm;
  @Prop() readonly onSuccess?: (
    imgae: string,
    newData?: BusinessOnboardingYourDigitalCoinsForm
  ) => void;

  coinSelectIds = {
    front: 'coin-mirror-svg-element-edit-front',
    back: 'coin-mirror-svg-element-edit-back'
  };

  shouldAddBusinessId = true;
  uploadFailed = false;

  form: BusinessOnboardingYourDigitalCoinsForm = {
    coinName: this.coinData.coinName.replace('$', ''),
    color: this.color,
    colorKey: this.coinData.colorKey || colorDefaultData.colorKey,
    image: this.coinData.image,
    coinShowFront: true,
    isLoadingImg: false
  };

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get color() {
    if (!this.coinData.color) return colorDefaultData.colorHex;

    return !this.coinData.color.includes('#')
      ? `#${this.coinData.color}`
      : this.coinData.color;
  }

  get componentToRender() {
    return isSafari() ? 'CoinAnatomySafari' : 'CoinAnatomy';
  }

  get imagePath() {
    return this.form.image ? this.form.image.imageUrl : '';
  }

  handleColorPickerInput(colorhex: string, colorKey: string) {
    this.form.colorKey = colorKey;
  }

  async onSubmit() {
    this.submitLoading = true;
    this.handleSubmit(this.form);
  }

  async handleReserveCoinInformations(
    payload: ReserveCoinInformations,
    formData: BusinessOnboardingYourDigitalCoinsForm,
    images?: Record<string, any>
  ) {
    const recaptchaCoinSetupReserve = await this.getRecaptcha(
      recaptchaRoutesKeys.businessCoinSetupReserve,
      flagKeys.businessCoinSetupReserveCaptcha
    );

    const { status, data = {} } = await this.service.updateCoinSetup(
      this.code,
      payload
    );

    if (status === 400) {
      this.$notification(
        String(this.$t(`${this.tPrefix}.errorReserveInfos`)),
        'error'
      );

      return;
    }

    let imageFrontData;

    if (images && images.frontImageResponse) {
      imageFrontData = images.frontImageResponse.data;
    } else if (data.coinFront2d) {
      imageFrontData = {
        publicPath: data.coinFront2d
      };
    }

    this.submitLoading = false;

    if (this.onSuccess) {
      this.onSuccess(imageFrontData.publicPath.small, formData);
      this.onClose();
    }
  }

  triggerUploadImageComponent() {
    const elementOfTrigger =
      this.form.image && this.form.image.imageUrl
        ? document.getElementById('image-upload-block-edit')
        : document.getElementById('image-upload-block');

    if (elementOfTrigger) {
      elementOfTrigger.click();
    }
  }
}
